import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'underscore'
import { sendTrackingData } from '@vmockinc/dashboard/services/tracking'
import {
  colorMap,
  symbolMap,
  feedbackContent,
  connectionBullet,
  iconMap,
} from '../Constants/PersonalInformationFeedback'
import { personalInformationFeedbackAriaLabel } from '../Constants/AriaLabelText'
import { InfoComponent } from '../HelperComponent/FeedbackBlock'
import InfoScreens from '../InfoScreens'
import { showUrlEditModal } from '../../actions/Edit'
import { injectIntl, FormattedMessage } from 'react-intl' // Added for intl support
import { showEditModal } from '../../actions/Edit'
import { redirectSelect } from '../../actions/AspireFeedback'
import { selectSection } from '../../actions/DetailedFeedback'
import { hashLinkScroll } from '../../services/helpers'

class PersonalInformation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showInfoScreen: false,
      lastFocusedElement: null,
      urlMessageOpen: false,
    }
    this.handleTracking = this.handleTracking.bind(this)
    this.handlePanelCollapse = this.handlePanelCollapse.bind(this)
    this.sendTrackingDataDebounce = _.debounce(sendTrackingData, 1500, true)
    this.toggleInfoScreen = this.toggleInfoScreen.bind(this)
    this.openUrlEdit = this.openUrlEdit.bind(this)
  }

  UNSAFE_componentWillMount() {
    this.props.setSelectedPanelPersonalInfo('name')
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      !prevProps.visited_sections.detailed_personal_info &&
      this.props.visited_sections.detailed_personal_info
    ) {
      this.setState({ urlMessageOpen: true })
    }
  }

  toggleInfoScreen() {
    this.setState({
      showInfoScreen: !this.state.showInfoScreen,
    })
  }

  setFocusOnActiveElement() {
    this.setState({ lastFocusedElement: document.activeElement })
  }

  getElementFocusedOnModalClose() {
    if (this.state.lastFocusedElement) {
      setTimeout(() => {
        this.state.lastFocusedElement.focus()
      }, 1)
    }
  }

  handleTracking(module) {
    let countOfAvailableClick = 3
    let jsonObjectForTracking = {
      eventLabel: 'feedback_panel_nav_personal_information_click_info',
      currentSection: 'Personal Information',
      selectedModule: module,
      countOfAvailableClick: countOfAvailableClick,
    }
    this.sendTrackingDataDebounce(
      'event',
      'aspire_detailed_feedback_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )
  }

  renderTop(sectionColor) {
    const { tabIndex, intl, isEditModal, showEditModal, selectSection, redirectSelect, fetchId } = this.props

    if (!_.isEmpty(sectionColor)) {
      sectionColor = sectionColor[0]['color']
      return (
        <>
          <div 
            className='feedback-panel-top-bar'
          >
            <button className='feedback-panel-back-button' onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              if (isEditModal) {
                showEditModal(false, '')
              }
              selectSection('Overall')
              redirectSelect(fetchId, 'detailed', 'Overall')
              hashLinkScroll()
            }}
            aria-label={intl.formatMessage({ id: "tour.button.back"})}>
              <span className='arrow arrow-right' />
            </button>
            <div 
              className='top-bar-section-name'
              role="heading"
              aria-level="3"
            >
              <FormattedMessage
                id="aspire.personalInformation.personalInformationHeading"
                defaultMessage="Personal Information"
              />
            </div>
            <div className='top-bar-divider' />
            <div 
              className={'top-bar-status text-' + sectionColor}
              tabIndex={tabIndex}
              aria-label={personalInformationFeedbackAriaLabel(intl)[sectionColor]}
            >
              {feedbackContent(intl)[sectionColor]['title_text']}{' '}
            </div>
          </div>
          <div className='feedback-panel-info-div'>
            <div className='feedback-panel-info-text'>
              {feedbackContent(intl)[sectionColor]['body']}
            </div>
          </div>
        </>
      )
    }

    return null
  }

  renderFeedbackMapText(section, color, feedback) {
    const { community, intl } = this.props
    let connections_threshold = 500
    if (feedback.hasOwnProperty('connections_threshold')) {
      connections_threshold = feedback['connections_threshold']
    }
    let feedbackMap = personalInformationFeedbackAriaLabel(intl, this.props.user && this.props.user.isResumeCalledCv)['feedbackMap']
    if (section === 'url' && community === 'nyustern') {
      return feedbackMap['nyu_stern_url'][color]
    }
    if (!_.isEmpty(section) && !_.isEmpty(color)) {
      return feedbackMap[section][color]
    }
    return null
  }

  renderProfileUrlNoteText(color) {
    const { community, intl } = this.props
    if (community === 'nyustern' && color !== 'green') {
      return (
        <div className="ps-panel-note" style={{ marginTop: '5px' }}>
          <FormattedMessage
            id="aspire.personalInformation.profileUrlNote"
            defaultMessage="Note: The suggested URLs may not be available. But you can try making a similar type of URL to optimize it."
          />
        </div>
      )
    }
    return null
  }

  handlePanelCollapse(activeKey) {
    let selected = 'name'
    if (activeKey == 1) {
      selected = 'name'
    } else if (activeKey == 2) {
      selected = 'profile_url'
    } else if (activeKey == 3) {
      selected = 'connections'
    }
    this.props.setSelectedPanelPersonalInfo(selected)
    this.handleTracking(selected)
  }

  openUrlEdit() {
    this.props.showUrlEditModal(true)
  }

  renderProfileUrlMessge() {
    const { urlMessageOpen } = this.state
    const { intl } = this.props
    return (
      <div
        className={`profile-infobox ${
          urlMessageOpen ? 'profile-infobox-open' : ''
        }`}
      >
        <div
          className="profile-infobox-heading"
          role="button"
          onClick={() => this.setState({ urlMessageOpen: !urlMessageOpen })}
        >
          <div className="heading" role="heading" aria-level="3">
            <FormattedMessage
              id="aspire.personalInformation.profileUrlSuggestionHeading"
              defaultMessage="Profile URL Suggestion"
            />
          </div>
          <span className="profile-infobox-heading__icon">
            {urlMessageOpen ? `–` : `+`}
          </span>
        </div>
        {urlMessageOpen && (
          <div className="profile-infobox-content">
            <p className="infobox-text">
              <FormattedMessage
                id="aspire.personalInformation.profileUrlSuggestionParagraph"
                defaultMessage="LinkedIn allows you to customize your profile URL. You may take inspiration from personalized URL suggestions inside Aspire edit mode to customize your URL. But please note that the URL suggested there may not be available."
              />
            </p>
            <div>
              <button
                tabIndex={0}
                aria-label={intl.formatMessage({
                  id: "aspire.personalInformation.viewSuggestionsButton",
                  defaultMessage: "Click to see more suggested profile urls. This will open a dialog."
                })}
                className="modified-button url-suggestion-btn"
                onClick={this.openUrlEdit}
                type="button"
              >
                <span className="url-suggestion-btn__text">
                  <FormattedMessage
                    id="aspire.personalInformation.viewSuggestionsButton"
                    defaultMessage="View Suggestions"
                  />
                </span>
                <span className="url-suggestion-btn__icon icon-rightarrow" />
              </button>
            </div>
          </div>
        )}
      </div>
    )
  }

  render() {
    const { currentSection, feedback, sectionWiseText, tabIndex, user, intl } =
      this.props
    const { community } = user
    let currentTab = tabIndex
    let noProfileUrl = community === 'nyustern'
    $('.panel-collapse').removeAttr('aria-expanded')
    return (
      <div>
        <div className="feedback-panel">
          {this.renderTop(feedback['section_score'])}
          <div 
            className='feedback-summary'
            id="personal-info-panel"
          >
            <div 
              className="feedback-parameter-section"
              tabIndex={currentTab}
              aria-label={`${personalInformationFeedbackAriaLabel(intl, this.props.user && this.props.user.isResumeCalledCv)['feedbackMap']['name'][feedback['name']]}`}
            >
              <div className='feedback-parameter-section-header'>
                <div className='feedback-parameter-status-icon'>
                  <img
                    alt=""
                    src={`${process.env.APP_BASE_URL}dist/images/${iconMap[feedback['name']]}`}
                    className="feedback-parameter-icon"
                  />
                </div>
                <div className="feedback-parameter-section-heading">
                  <FormattedMessage
                    id="aspire.personalInformation.profileNameHeading"
                    defaultMessage="Profile Name"
                  />
                </div> 
              </div>
              <div className='feedback-parameter-section-detail'>
                {this.renderFeedbackMapText('name', feedback['name'], feedback)}
              </div>
            </div>
            {!noProfileUrl ? (
              <div 
                className="feedback-parameter-section"
                tabIndex={currentTab}
                aria-label={`${personalInformationFeedbackAriaLabel(intl)['feedbackMap']['url'][feedback['url']]}`}
              >
                <div className='feedback-parameter-section-header'>
                  <div className='feedback-parameter-status-icon'>
                    <img
                      alt=""
                      src={`${process.env.APP_BASE_URL}dist/images/${iconMap[feedback['url']]}`}
                      className="feedback-parameter-icon"
                    />
                  </div>
                  <div className="feedback-parameter-section-heading">
                    <FormattedMessage
                      id="aspire.personalInformation.profileUrlHeading"
                      defaultMessage="Profile URL"
                    />
                  </div> 
                </div>
                <div className='feedback-parameter-section-detail'>
                  {this.renderFeedbackMapText('url', feedback['url'], feedback)}
                </div>
              </div>
            ) : null}
          </div>
          {noProfileUrl && this.renderProfileUrlMessge()}
        </div>
        <InfoScreens
          show={this.state.showInfoScreen}
          module="connection"
          hideModal={this.toggleInfoScreen}
          extendModalClass="info-connection-modal"
        />
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    user: state.user.data,
    isUrlEditModal: state.editData.show_url_edit_modal,
    visited_sections: state.aspireFeedbackData.visited_sections,
    isEditModal: state.editData.show_edit_modal,
  }
}

export default connect(mapStateToProps,
  { showUrlEditModal,
    showEditModal,
    redirectSelect,
    selectSection,
   })(
  injectIntl(PersonalInformation)
)